module.exports = __webpack_public_path__ + "static/media/Position_9m.6871ca0d.jpg";